import type { ReactNode } from "react";

export type StatusBannerVariant = "pilot" | "preview" | "draft" | "info" | "staging";

const VARIANT: Record<StatusBannerVariant, { className: string }> = {
	/** Soft gold-ink wash — staging pilot notices. */
	pilot: {
		className: "border-[#EF9F27] bg-[#FAEEDA] text-[#633806]",
	},
	/** Alias of pilot hex set (PRD §2.7 staging). */
	staging: {
		className: "border-[#EF9F27] bg-[#FAEEDA] text-[#633806]",
	},
	preview: {
		className: "border-wi-border-strong bg-wi-ink-soft text-wi-text-secondary",
	},
	/** Draft — never harsh red (PRD §2.7). */
	draft: {
		className: "border-wi-border-strong bg-[#F1EFE8] text-wi-text-secondary",
	},
	info: {
		className: "border-wi-signal/35 bg-wi-signal-bg text-wi-signal",
	},
};

type Props = {
	variant: StatusBannerVariant;
	children: ReactNode;
	className?: string;
};

/**
 * Unified draft / staging / preview notice — soft tokens / PRD hex only (no harsh red).
 */
export function StatusBanner({ variant, children, className = "" }: Props) {
	const banner = VARIANT[variant];
	return (
		<p
			className={[
				"rounded-lg border px-5 py-3 text-body-sm leading-relaxed",
				banner.className,
				className,
			]
				.filter(Boolean)
				.join(" ")}
			role="status"
		>
			{children}
		</p>
	);
}
